import React from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';

import {ACCOUNT_TABS} from 'src/constants';
import {STATSIG_GATES} from 'src/contexts/statsig-contex';

import {useGateValue} from '@pb/kit-lib-statsig';


import {AccountEntitlementsSubTab} from './assigned/account-entitlements-subtab';
import {ENTITLEMENTS_SUB_TABS} from './constants';
import {DatasetEntitlementsSubTab} from './dataset/dataset-entitlements-subtab';
import {McpEntitlementsSubTab} from './mcp/mcp-entitlements-subtab';

type Props = {
    accountId: number,
};

export const EntitlementsWrapper = ({accountId}: Props) => {
    const isDatasetEnabled = useGateValue(STATSIG_GATES.DATASET_ENTITLEMENTS);
    return (
        <Routes>
            <Route
                path={`/${ENTITLEMENTS_SUB_TABS.ACCOUNT_ENTITLEMENTS.name}`}
                element={<AccountEntitlementsSubTab accountId={accountId}/>}
            />
            <Route
                path={`/${ENTITLEMENTS_SUB_TABS.MCP_ENTITLEMENTS.name}`}
                element={<McpEntitlementsSubTab accountId={accountId}/>}
            />
            {isDatasetEnabled ? (
                <Route
                    path={`/${ENTITLEMENTS_SUB_TABS.DATASET_ENTITLEMENTS.name}`}
                    element={<DatasetEntitlementsSubTab accountId={accountId}/>}
                />
            ) : null}
            <Route
                path="*"
                element={(
                    <Navigate
                        to={
                            `/profile/account/${accountId}/` +
                            `${ACCOUNT_TABS.ENTITLEMENTS.name}/` +
                            `${ENTITLEMENTS_SUB_TABS.ACCOUNT_ENTITLEMENTS.name}`
                        }
                    />
                )}
            />
        </Routes>
    );
};
